export const GET_PENSIONS = 'SENIOR_CITIZEN_SETTINGS/get_pensions';
export const SHOW_PENSION = 'SENIOR_CITIZEN_SETTINGS/show_pension';
export const CREATE_PENSION = 'SENIOR_CITIZEN_SETTINGS/create_pension';
export const UPDATE_PENSION = 'SENIOR_CITIZEN_SETTINGS/update_pension';
export const REMOVE_PENSION = 'SENIOR_CITIZEN_SETTINGS/remove_pension';

export const FORM_DATA = {
  code: '',
  is_active: 0,
  name: '',
};
